// Recorded-value semantics. Missing data is Unknown — never coerced to zero.

export const ValueKind = {
  Unknown: 'Unknown',
  ConfirmedZero: 'ConfirmedZero',
  NA: 'N/A',
  Recorded: 'Recorded',
};

/**
 * Parse a numeric field without treating blank as 0.
 * Empty / null / undefined / non-numeric → Unknown.
 * Explicit 0 → ConfirmedZero.
 */
export function measure(raw) {
  if (raw === null || raw === undefined || raw === '') {
    return { kind: ValueKind.Unknown, value: null, recorded: false };
  }
  const n = typeof raw === 'number' ? raw : parseFloat(String(raw).replace(/[, ]/g, ''));
  if (!Number.isFinite(n)) {
    return { kind: ValueKind.Unknown, value: null, recorded: false };
  }
  if (n === 0) {
    return { kind: ValueKind.ConfirmedZero, value: 0, recorded: true };
  }
  return { kind: ValueKind.Recorded, value: n, recorded: true };
}

export function isUnknown(m) {
  return !m || m.kind === ValueKind.Unknown;
}

export function displayMeasure(m, { unknown = 'Unknown', zero = '0' } = {}) {
  if (!m || m.kind === ValueKind.Unknown) return unknown;
  if (m.kind === ValueKind.NA) return 'N/A';
  if (m.kind === ValueKind.ConfirmedZero) return zero;
  return String(m.value);
}
